<template>
  <pannel-box @close="closeDialog" headerName="水表" :headerData="headerData">
    <div class="detail">
      <div
        class="contentList"
        v-for="(item, key, index) in botData"
        :key="index"
      >
        <div class="text" @click="chooseData(key)">{{ key }}</div>
        <div
          class="value"
          :class="item.alarm == '0' ? 'normalData-color' : 'alarm-color '"
        >
          {{ showItem(item.value)
          }}<span class="detail-unit-data">{{ showUnit(item.value) }}</span>
        </div>
      </div>
    </div>
    <div class="time-type-select">
      <div
        class="time-type-item"
        :id="timeValue == 'day' ? 'active' : ''"
        @click="changeDay('day')"
      >
        时
      </div>
      <div
        class="time-type-item"
        :id="timeValue == 'month' ? 'active' : ''"
        @click="changeDay('month')"
      >
        日
      </div>
      <div
        class="time-type-item"
        :id="timeValue == 'year' ? 'active' : ''"
        @click="changeDay('year')"
      >
        月
      </div>
    </div>
    <div class="bot-content">
      <custom-charts
        :title="dataBtn"
        :dataList="dataList"
        :timer="timeValue"
      ></custom-charts>
    </div>
  </pannel-box>
</template>

<script>
export default {
  data() {
    return {
      waterNum: "(-)",
      timeValue: "day",
      dataList: {
        x: [],
        y: [],
      },
      map: {
        day: "当日",
        month: "当月",
        year: "当年",
      },
      dataBtn: "用水量",
    };
  },
  computed: {
    headerData() {
      return this.meterData?.baseData;
    },
    botData() {
      return this.meterData?.collectionValue.data;
    },
  },
  props: {
    isShowDialog: Boolean,
    meterData: Object,
  },
  watch: {
    meterData() {
      this.getChartData();
    },
    dataBtn() {
      this.getChartData();
    },
  },
  created() {
    this.dataBtn = "用水量";
    this.getChartData();
  },
  methods: {
    loadData(first, end) {
      this.dataList = { x: [], y: [] };
      if (this.meterData?.historical?.[this.timeValue]?.[this.dataBtn]) {
        this.meterData?.historical?.[this.timeValue]?.[this.dataBtn].map(
          (item, index) => {
            let [res] = Object.entries(item);
            this.dataList.x.push(res[0].slice(first, end));
            this.dataList.y.push(res[1]);
          }
        );
      }
    },
    chooseData(i) {
      this.dataBtn = i;
    },
    showItem(val) {
      if (val.includes(".")) {
        return val.split(".")[0] + "." + val.split(".")[1].slice(0, 2);
      } else if (val == "暂无数据") {
        return "-";
      } else {
        return val;
      }
    },
    showUnit(val) {
      if (val.includes(".")) {
        return val.split(".")[1].slice(2);
      }
    },
    changeDay(value) {
      this.timeValue = value;
      this.getChartData();
    },
    getChartData() {
      if (this.timeValue == "day") {
        this.loadData(10, 13);
      } else if (this.timeValue == "month") {
        this.loadData(8, 11);
      } else {
        this.loadData(5, 8);
      }
    },
    setEquName(val) {
      if (!val) {
        return "-";
      } else {
        return val.baseData.eqpName;
      }
    },
    closeDialog() {
      this.$emit("foo");
    },
  },
};
</script>

<!-- 水能耗 -->
<style lang="scss" scoped>
.detail {
  display: grid;
  grid-template-columns: 160px 160px;
  // grid-template-rows: repeat(5, 29px);
  gap: 4px 20px;
  overflow: hidden;
  .contentList {
    padding: 3.5px 4px;
    display: flex;
    justify-content: space-between;
    width: 165px;
    font-size: 14px;
    color: rgba(239, 239, 239, 0.7);
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
    .value {
      width: 91px;
      text-align: right;
    }
    .normalData-color {
      color: #fff;
    }
    .alarm-color {
      color: #f1802f;
    }
    .text {
      // color: #fff;
      width: 62px;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      // white-space: pre-wrap;
    }
  }
}
.time-type-select {
  display: flex;
  align-items: center;
  .time-type-item {
    margin-right: 7px;
    width: 40px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }

  .time-type-item:last-child {
    margin-right: 0;
  }
  #active {
    background: rgba(175, 175, 175, 0.2);
  }
}

.bot-content {
  margin-top: 15px;
  width: 341px;
  height: 140px;
}
.water-content {
  position: relative;
  margin: 20px;
  .top-water-num {
    width: 376px;
    height: 33px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    color: #fff;
    font-weight: 500;
    font-size: 22px;
    line-height: 33px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
